module.exports = __webpack_public_path__ + "165aab51ea88b3a4bb8c1abe9ae3dd5e.MP3";